import { Grid, Typography } from "@mui/material";
import JsonInput from "atoms/JsonInput";
import { BooleanInput, NumberInput, TextInput, useTranslate } from "react-admin";
import { useWatch } from "react-hook-form";

export default function PortalFields() {
  const translate = useTranslate();
  const isPortalActive = useWatch<{ is_portal_active: boolean }>({ name: "is_portal_active" });

  return (
    <>
      <Grid item xs={12}>
        <BooleanInput
          source="is_portal_active"
          label={translate("settings.is_portal_active.name")}
          helperText={translate("settings.is_portal_active.description")}
        />
      </Grid>
      {isPortalActive && (
        <>
          <Grid item xs={12} md={4}>
            <BooleanInput
              source="public_portal_registration"
              label={translate("settings.public_portal_registration.name")}
              helperText={translate("settings.public_portal_registration.description")}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <BooleanInput
              source="create_organization_with_account"
              label={translate("settings.create_organization_with_account.name")}
              helperText={translate("settings.create_organization_with_account.description")}
            />
          </Grid>
          <Grid item xs={0} md={4} />
          <Grid item xs={12} md={6}>
            <TextInput
              source="login_text"
              label={translate("settings.login_text.name")}
              helperText={translate("settings.login_text.description")}
              multiline
              minRows={3}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">{translate("settings.headlines.lecturers")}</Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <NumberInput
              source="days_lecturers_may_change_attendance_after_event"
              label={translate("settings.days_lecturers_may_change_attendance_after_event.name")}
              helperText={translate("settings.days_lecturers_may_change_attendance_after_event.description")}
            />
          </Grid>
          <Grid item xs={0} md={9} />
          <Grid item xs={12} md={4}>
            <BooleanInput
              source="lecturer_booking_export_active"
              label={translate("settings.lecturer_booking_export_active.name")}
              helperText={translate("settings.lecturer_booking_export_active.description")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BooleanInput
              source="lecturer_emailing_active"
              label={translate("settings.lecturer_emailing_active.name")}
              helperText={translate("settings.lecturer_emailing_active.description")}
            />
          </Grid>
          <Grid item xs={0} md={6} />
          <Grid item xs={12} mb={4}>
            <JsonInput
              source="custom_theme"
              label={translate("settings.custom_theme.name")}
              helperText={translate("settings.custom_theme.description")}
              minRows={6}
              defaultExpanded={false}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">{translate("settings.headlines.cancellation")}</Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <NumberInput
              source="cancellation_period"
              label={translate("settings.cancellation_period.name")}
              helperText={translate("settings.cancellation_period.description")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput
              source="cancellation_contact_email"
              label={translate("settings.cancellation_contact_email.name")}
              helperText={translate("settings.cancellation_contact_email.description")}
            />
          </Grid>
        </>
      )}
    </>
  );
}
